module.exports = __webpack_public_path__ + "img/pic-slider-2.96d3aef.webp";